import React, { useEffect, useState } from 'react'
import {
    Box,
    FormControl,
    Grid,
    MenuItem,
    Select,
    Typography
} from '@mui/material'
import { UserCommonStyles } from '../../styles/CommonStyles'
import LeftSidebar from '../../components/sidebars/LeftSidebar';
import SocialIconSection from '../../components/sidebars/SocialIconSection';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getAdImpressionOnAd, getAdVisitsOnAd } from '../../redux/action-creators/adAction';
import moment from 'moment';

const uData = [
    { name: 'OCT 6', value: 100 },
    { name: 'OCT 7', value: 600 },
    { name: 'OCT 8', value: 480 },
    { name: 'OCT 9', value: 900 },
    { name: 'OCT 10', value: 410 },
    { name: 'OCT 11', value: 700 },
    { name: 'OCT 12', value: 970 },
];
const uData2 = [
    { name: 'OCT 6', value: 120 },
    { name: 'OCT 7', value: 205 },
    { name: 'OCT 8', value: 135 },
    { name: 'OCT 9', value: 350 },
    { name: 'OCT 10', value: 110 },
    { name: 'OCT 11', value: 300 },
    { name: 'OCT 12', value: 397 },
];

const numberFormatter = /\B(?=(\d{3})+(?!\d))/g;

const AdStatsGraph = () => {
    const ad_id = Number(useParams<{ id: string }>().id);
    const commonStyle = UserCommonStyles();
    const dispatch = useDispatch();

    // Impression stats
    const [adImpressionStatus, setAdImpressionStatus] = React.useState<string>("");
    const [adImpressionArray, setAdImpressionArray] = useState<any>([]);
    const [adImpressionCount, setAdImpressionCount] = useState<number>(0);
    const [adImpressionLoader, setAdImpressionLoader] = useState<boolean>(false);
    // Visits stats
    const [adVisitStatus, setAdVisitStatus] = useState<string>("");
    const [adVisitsArray, setAdVisitsArray] = useState<any>([]);
    const [adVisitsCount, setAdVisitsCount] = useState<number>(0);
    const [adVisitsLoader, setAdVisitsLoader] = useState<boolean>(false);

    useEffect(() => {
        getAdImpressionData("7", true);
        getAdVisitsData("7", true);
    }, []);

    /**
  * add impression data
  * @param impressionStatus
  * @param loader
  * @returns
  */
    const getAdImpressionData = async (impressionStatus: string, loader: boolean) => {
        if (impressionStatus === adImpressionStatus) return;
        setAdImpressionStatus(impressionStatus);
        setAdImpressionCount(0);
        setAdImpressionLoader(loader);
        const temp = [];
        const data = {
            ad_id: ad_id,
            month: impressionStatus === "month" ? new Date().getMonth() + 1 : null,
            monthlyDate: impressionStatus === "month" ? "" : impressionStatus
        };
        const response: any = await dispatch(getAdImpressionOnAd(data));
        if (response && response?.data?.length > 0) {
            response?.data.map((item: any) => {
                const newObject = {
                    date: moment(item?.views_date).format('MMM D'),
                    Impression: item?.impressions // Math.floor(Math.random() * 900) + 100
                };
                setAdImpressionCount((count) => count + item?.impressions); // newObject?.Impression
                temp.unshift(newObject);
            });
            setAdImpressionArray(temp);
            setAdImpressionLoader(false);
        } else {
            setAdImpressionArray([]);
            setAdImpressionLoader(false);
        };
    };

    /**
* add visits data
* @param impressionStatus
* @param loader
* @returns
*/
    const getAdVisitsData = async (VisitsStatus: string, loader: boolean) => {
        if (VisitsStatus === adVisitStatus) return;
        setAdVisitStatus(VisitsStatus);
        setAdVisitsCount(0);
        setAdVisitsLoader(loader);
        const temp = [];
        const data = {
            ad_id: ad_id,
            month: VisitsStatus === "month" ? new Date().getMonth() + 1 : null,
            monthlyDate: VisitsStatus === "month" ? "" : VisitsStatus
        };
        const response: any = await dispatch(getAdVisitsOnAd(data));
        if (response && response?.data?.length > 0) {
            response?.data.map((item: any) => {
                const newObject = {
                    date: moment(item?.visit_date).format('MMM D'),
                    Visits: item?.web_visits // Math.floor(Math.random() * 900) + 100 
                };
                setAdVisitsCount((count) => count + item?.web_visits); // newObject?.Visits
                temp.unshift(newObject);
            });
            setAdVisitsArray(temp);
            setAdVisitsLoader(false);
        } else {
            setAdVisitsArray([]);
            setAdVisitsLoader(false);
        };
    };

    return (
        <Box className={commonStyle.windowColor}>
            <Grid container>
                <Grid item md={3}>
                    <LeftSidebar />
                    {/* <SocialIconSection /> */}
                </Grid>

                <Grid item md={9}>
                    <Box className={commonStyle.p20}>
                        <Box className={`${commonStyle.mb15} ${commonStyle.mt40}`}>
                            <Typography
                                variant="h6"
                                className={`${commonStyle.grey} ${commonStyle.fontWeight600} ${commonStyle.f_family_Roboto}`}
                            >
                                Ad Stats
                            </Typography>
                        </Box>

                        {/* First Stats Graph /////////////// */}
                        <Box pt={15} className={`${commonStyle.p20} ${commonStyle.card}`}>
                            <Grid container spacing={0}>
                                <Grid item md={1}></Grid>
                                <Grid item md={10} className={commonStyle.shadow}>
                                    <Grid container spacing={0}>
                                        <Grid item md={12}  >
                                            <Box pt={5} pl={5} pr={5} pb={5}>
                                                <Box
                                                    className={`${commonStyle.dflex} ${commonStyle.justifySpaceBetween} ${commonStyle.alignItemsCenter}`}>
                                                    <Box
                                                        style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "flex-start",
                                                            alignItems: "flex-start"
                                                        }}
                                                    >
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight500} ${commonStyle.font18} ${commonStyle.f_family_Roboto}`}
                                                        >Ad Stats
                                                        </Typography>
                                                        <Typography variant="h6" mt={1}
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight600} ${commonStyle.font24} ${commonStyle.f_family_Roboto}`}
                                                        >
                                                            {adImpressionCount > 0 ? adImpressionCount.toString().replace(numberFormatter, ",") : "0"}
                                                        </Typography>
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.font14} ${commonStyle.f_family_Roboto}`}
                                                        >Ad Impression
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <FormControl sx={{ m: 0, minWidth: 120, }}>
                                                            <Select
                                                                style={{
                                                                    width: 210,
                                                                    height: 56,
                                                                    borderWidth: 1,
                                                                    borderColor: "#949494",
                                                                    borderRadius: "4px"
                                                                }}
                                                                value={adImpressionStatus}
                                                                onChange={(event: any) => getAdImpressionData(event.target.value, false)}
                                                                displayEmpty
                                                                inputProps={{ 'aria-label': 'Without label' }}
                                                            >
                                                                <MenuItem value={"today"}>Today</MenuItem>
                                                                <MenuItem value={"yesterday"}>Yesterday</MenuItem>
                                                                <MenuItem value={"7"}>Last 7 days</MenuItem>
                                                                <MenuItem value={"month"}>Last 30 days</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                </Box>
                                                <Box mt={7} sx={{ display: "flex", justifyContent: "center", }}>
                                                    {adImpressionArray.length > 0 ? (
                                                        <BarChart
                                                            width={600}
                                                            height={300}
                                                            data={adImpressionArray}
                                                        >
                                                            <CartesianGrid stroke="none" />
                                                            <XAxis dataKey="date" fontSize={11} />
                                                            <YAxis dataKey="Impression" fontSize={11} fill='#01B4BC' />
                                                            <Tooltip />
                                                            <Bar dataKey="Impression" fill="#01B4BC" barSize={10} />
                                                        </BarChart>
                                                    ) : adImpressionLoader ? (
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.font14} ${commonStyle.f_family_Roboto}`}
                                                        >
                                                            Loading ...
                                                        </Typography>
                                                    ) : (
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.font14} ${commonStyle.f_family_Roboto}`}
                                                        >
                                                            Data not found
                                                        </Typography>
                                                    )}
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={1}></Grid>
                            </Grid>
                        </Box>
                        {/* Second Stats Graph /////////////// */}
                        <Box pt={15} className={`${commonStyle.p20} ${commonStyle.card}`}>
                            <Grid container spacing={0}>
                                <Grid item md={1}></Grid>
                                <Grid item md={10} className={commonStyle.shadow}>
                                    <Grid container spacing={0}>
                                        <Grid item md={12}  >
                                            <Box pt={5} pl={5} pr={5} pb={3}>
                                                <Box mb={1}>
                                                    <Typography variant="h6"
                                                        className={`${commonStyle.black} ${commonStyle.fontWeight500} ${commonStyle.font24} ${commonStyle.f_family_Roboto}`}
                                                    >Website Visit
                                                    </Typography>
                                                </Box>
                                                <Box
                                                    className={`${commonStyle.dflex} ${commonStyle.justifySpaceBetween} ${commonStyle.alignItemsCenter}`}
                                                >
                                                    <Box style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "flex-start",
                                                            alignItems: "flex-start"
                                                        }}
                                                    >
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight500} ${commonStyle.font18} ${commonStyle.f_family_Roboto}`}
                                                        >Performance
                                                        </Typography>
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight600} ${commonStyle.font24} ${commonStyle.f_family_Roboto}`}
                                                        >
                                                            {adVisitsCount > 0 ? adVisitsCount.toString().replace(numberFormatter, ",") : "0"}
                                                        </Typography>
                                                    </Box>
                                                    <Box>
                                                        <FormControl sx={{ m: 0, minWidth: 120, }}>
                                                            <Select style={{
                                                                    width: 190,
                                                                    height: 56,
                                                                    borderWidth: 1,
                                                                    borderColor: "#949494",
                                                                    borderRadius: "4px"
                                                                }}
                                                                value={adVisitStatus}
                                                                onChange={(event: any) => getAdVisitsData(event.target.value, false)}
                                                                displayEmpty
                                                                inputProps={{ 'aria-label': 'Without label' }}
                                                            >
                                                                <MenuItem value={"today"}>Today</MenuItem>
                                                                <MenuItem value={"yesterday"}>Yesterday</MenuItem>
                                                                <MenuItem value={"7"}>Last 7 days</MenuItem>
                                                                <MenuItem value={"month"}>Last 30 days</MenuItem>
                                                            </Select>
                                                        </FormControl>
                                                    </Box>
                                                </Box>
                                                <Box mt={7} sx={{ display: "flex", justifyContent: "center", }}>
                                                    {adVisitsArray.length > 0 ? (
                                                        <BarChart
                                                            width={600}
                                                            height={300}
                                                            data={adVisitsArray}
                                                        >
                                                            <CartesianGrid stroke="none" />
                                                            <XAxis dataKey="date" fontSize={11} />
                                                            <YAxis dataKey="Visits" fontSize={11} fill='#01B4BC' />
                                                            <Tooltip />
                                                            <Bar dataKey="Visits" fill="#01B4BC" barSize={10} />
                                                        </BarChart>
                                                    ) : adVisitsLoader ? (
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.font14} ${commonStyle.f_family_Roboto}`}
                                                        >
                                                            Loading ...
                                                        </Typography>
                                                    ) : (
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.font14} ${commonStyle.f_family_Roboto}`}
                                                        >
                                                            Data not found
                                                        </Typography>
                                                    )}
                                                </Box>
                                                {/* Line //////////////////// */}
                                                <div style={{
                                                    backgroundColor: "#BDBDBD",
                                                    height: 1,
                                                    marginTop: "30px"
                                                }} />
                                                <Box mt={2} mb={2}
                                                    className={`${commonStyle.dflex} ${commonStyle.justifySpaceAround} ${commonStyle.alignItemsCenter}`}
                                                >
                                                    <Box style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "flex-start",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <Typography variant="h6" mt={1}
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight600} ${commonStyle.font24} ${commonStyle.f_family_Roboto}`}
                                                        >

                                                            {adImpressionCount > 0 ? adImpressionCount.toString().replace(numberFormatter, ",") : "0"}
                                                        </Typography>
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.font20} ${commonStyle.f_family_Roboto}`}
                                                        >Impression
                                                        </Typography>
                                                    </Box>
                                                    <Box style={{
                                                            display: "flex",
                                                            flexDirection: "column",
                                                            justifyContent: "flex-start",
                                                            alignItems: "center"
                                                        }}
                                                    >
                                                        <Typography variant="h6" mt={1}
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight600} ${commonStyle.font24} ${commonStyle.f_family_Roboto}`}
                                                        >

                                                            {adVisitsCount > 0 ? adVisitsCount.toString().replace(numberFormatter, ",") : "0"}
                                                        </Typography>
                                                        <Typography variant="h6"
                                                            className={`${commonStyle.black} ${commonStyle.fontWeight400} ${commonStyle.font20} ${commonStyle.f_family_Roboto}`}
                                                        >Click-through rate
                                                        </Typography>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item md={1}></Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};

export default AdStatsGraph;